import React, { useEffect, useState } from 'react';

import { useTheme } from '@chakra-ui/react';
import { Button, Tooltip, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@mesh.ai/rabbit';
import { AgGridReact } from 'ag-grid-react';

import { CollapseAll, ExpandAll } from 'assets/assetsV1/iconComponents';

import { notNullOrUndefined } from 'constants/helper';

import { UserDataPersistenceService } from 'services/UserDataPersistenceService';

type Props = {
  gridRef: React.RefObject<AgGridReact>;
  defaultExpandAll: boolean;
  onExpandCollapse?: () => void;
};

const AgGridExpandCollapseButton = ({ gridRef, defaultExpandAll, onExpandCollapse }: Props) => {
  const theme = useTheme();
  const [isExpandAllActive, setIsExpandAllActive] = useState(defaultExpandAll);

  //   fix the type in original AgGridWrapper.jsx
  //   @ts-ignore
  const gridStatePersistenceKey = gridRef?.current?.props?.gridStatePersistenceKey;

  useEffect(() => {
    const checkAndUpdateExpandAllActive = async () => {
      const persistedGridState = await UserDataPersistenceService.get(gridStatePersistenceKey);
      if (persistedGridState) {
        const persistedExpandAllState = persistedGridState?.expandAll;
        if (notNullOrUndefined(persistedExpandAllState)) {
          setIsExpandAllActive(persistedExpandAllState);
          return;
        }
      }
      setIsExpandAllActive(defaultExpandAll);
    };
    checkAndUpdateExpandAllActive();
  }, [defaultExpandAll, gridStatePersistenceKey]);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Button
            size="icon"
            variant="text"
            onClick={() => {
              setIsExpandAllActive(!isExpandAllActive);

              if (isExpandAllActive) {
                gridRef?.current?.api?.collapseAll();
              } else {
                gridRef?.current?.api?.expandAll();
              }

              if (typeof onExpandCollapse === 'function') onExpandCollapse();
            }}
          >
            {isExpandAllActive ? (
              <CollapseAll boxSize="24px" color={theme.colors.icon['1565BC']} />
            ) : (
              <ExpandAll boxSize="24px" color={theme.colors.icon['1565BC']} />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent>
            <p>{isExpandAllActive ? 'Collapse all' : 'Expand all'}</p>
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
};

export { AgGridExpandCollapseButton };
